<template>
  <div class="footer-wrapper">
    <footer class="main-footer">
      <div class="container">
        <div class="level is-title">
          <div class="level-left">
            <div class="level-item">
              <nav>
                <ul class="footer-links">
                  <li>
                    <router-link
                      class="clickable footer-link"
                      tag="a"
                      :to="{ name: 'terms' }"
                      v-t="`${langRoot}.termsAndConditions`"
                    />
                  </li>
                  <li>
                    <router-link
                      class="clickable footer-link"
                      tag="a"
                      :to="{ name: 'dataprivacy' }"
                      v-t="`${langRoot}.dataPrivacy`"
                    ></router-link>
                  </li>
                  <li>
                    <router-link
                      class="clickable footer-link"
                      tag="a"
                      :to="{ name: 'cookiepolicy' }"
                      v-t="`${langRoot}.cookiePolicy`"
                    ></router-link>
                  </li>
                  <li v-for="(link, index) in links" :key="`link--${index}`">
                    <a class="footer-link" :href="link.href" target="_blank">
                      <i8-icon class="icon footer-link__icon" :icon="link.icon"/>
                      {{$t(`${langRoot}.security`)}}
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <li>{{$t(`${langRoot}.copyrightNotice`, {copyrightSymbol: '©', year: currentYear})}}</li>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>


<script>
const name = 'ii-footer';
import I8Icon from '@shared/components/I8Icon';
export default {
    name,
    componentName: name,
    components: {
        [I8Icon.name]: I8Icon,
    },
    data() {
        return {
            langRoot: 'footer',
            links: [
                {
                    href: 'http://www.hsbc.com/online-banking/online-security',
                    icon: 'security-lock',
                },
            ],
        };
    },

    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
    },
};
</script>



// WEBPACK FOOTER //
// shared/components/Footer.vue